import React from 'react';
import {useFormContext} from 'react-hook-form';
import {FormBlock, FormBlockFieldCustomizeItem} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldCustomizeItem;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const blockable = block.formBlockable;
  const {poolProspectCustomizeItem} = blockable;
  const {
    register,
    formState: {errors = {}},
  } = useFormContext();
  const error: any = errors[block.id];
  const errorMessage = error?.message;

  return (
    <div className="w-full">
      <div className="flex gap-1 mb-2 items-center">
        <label className="tracking-wide font-bold">
          {poolProspectCustomizeItem.name}
        </label>
        {blockable.isRequired && <span className="text-red-500">*</span>}
      </div>
      <div className="flex flex-col gap-1">
        {poolProspectCustomizeItem.selectOptions.map((option) => (
          <label key={option.id} className="flex items-center">
            <input
              type="checkbox"
              value={option.id}
              className="form-checkbox h-5 w-5 rounded"
              {...register(block.id)}
            />
            <span className="ml-2">{option.label}</span>
          </label>
        ))}
      </div>
      {errorMessage && <div className="text-red-500">{errorMessage}</div>}
    </div>
  );
};
